import axios from 'axios';

const API_URL = 'https://api.blogfortis.com/api/blog/'
const web = '36203df8-2ab2-48ba-b3e9-b64817e60338';

const getAllBlogs = async (page = 0, size = 10) => {
    try {
        const response = await axios.get(API_URL + 'web', {
            params: { page, size, web }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Failed to fetch blogs');
    }
};

const getBlogByTitle = async (title) => {
    try {
        const response = await axios.get(API_URL + 'by-title', {
            params: { web, title }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Failed to fetch blog');
    }
};

const BlogService = {
    getAllBlogs,
    getBlogByTitle
};

export default BlogService;
